import { AutogenModelEdiCompareHist, AutogenRowEdiCompareHist } from "./autogen/AutogenModelEdiCompareHist";

export class ModelEdiCompareHist extends AutogenModelEdiCompareHist<RowEdiCompareHist> {
	constructor() {
		super(RowEdiCompareHist);
	}
}

export class RowEdiCompareHist extends AutogenRowEdiCompareHist {
}